<template>
  <div class="mask user-select-none" @click.self="onClickOutSide">
    <div v-if="isLinking" class="flex flex-center">
      <vue-loading type="spiningDubbles" color="#efad4c" :size="{ width: '25px', height: '25px' }" />
    </div>
    <div v-else class="dialog flex flex-column line-height-initial">
      <div class="header flex flex-row space-between">
        <span v-if="isPost" class="bold">Nolaノベルでエピソードを公開する</span>
        <span v-else class="bold">Nolaノベルのエピソードと連携する</span>
        <span class="pointer" @click="onNegativeClick">×ウィンドウを閉じる</span>
      </div>
      <div class="content flex flex-row flex-1">
        <div class="flex flex-column flex-6 scroll">
          <div
            v-if="linkedNovel"
            class="flex flex-row px-1 gap-1 align-items-center"
            :style="{ paddingTop: '1.0rem', paddingBottom: '1.0rem' }"
          >
            <chevron-left-icon
              v-if="!novelIdFromNolaNovel"
              class="flex flex-center pointer"
              :size="20"
              fillColor="#909090"
              @click="linkedNovel = undefined"
            />
            <div class="flex flex-center">
              <image-view :src="getImagePath(linkedNovel)" :style="{ height: '35px', width: '25px' }" />
            </div>
            <div class="flex-1 flex align-items-center" :style="{ minWidth: '0px' }">
              <h3 class="line-3 w-full m-0">
                {{ linkedNovel.title }}
              </h3>
            </div>
          </div>
          <div v-else>
            <h2 v-if="isPost" class="px-1">Nolaノベルのどの作品に原稿を投稿しますか？</h2>
            <h2 v-else class="px-1">Nolaノベルのどの作品と原稿を連携しますか？</h2>
            <div v-if="isPost" class="flex flex-column">
              <div class="light-gray px-1 py-1">
                <span class="gray">新規の作品投稿</span>
              </div>
              <div class="w-full" :style="{ height: '1px', background: '#D6D6D6' }" />
              <div class="novel-list-row">
                <div
                  class="flex flex-row px-1 gap-1 align-items-center"
                  :style="{ paddingTop: '1.0rem', paddingBottom: '1.0rem' }"
                >
                  <div class="flex-1 flex align-items-center">
                    <h3 class="line-3 w-full m-0">新規の作品として投稿する</h3>
                  </div>
                  <div class="btn new pointer" @click="onDetailNavigateClick">選択</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="linkedNovel && isPost" class="flex flex-column">
            <div class="light-gray px-1 py-1">
              <span class="gray">新規のエピソード投稿</span>
            </div>
            <div class="w-full" :style="{ height: '1px', background: '#D6D6D6' }" />
            <div class="episode-list-row">
              <div
                class="flex flex-row px-1 gap-1 align-items-center"
                :style="{ paddingTop: '1.0rem', paddingBottom: '1.0rem' }"
              >
                <div class="flex-1 flex align-items-center">
                  <h3 class="line-3 w-full m-0">この原稿を新規のエピソードとして投稿する</h3>
                </div>
                <div class="btn new pointer" @click="navigateToNolaNovelEditPage()">選択</div>
              </div>
            </div>
          </div>
          <div class="flex flex-column">
            <div v-if="linkedNovel" class="light-gray px-1 py-1">
              <div class="flex flex-row">
                <span class="gray flex-1">Nolaノベルに投稿済みのエピソードにこの原稿を上書きする</span>
                <sort-variant-icon
                  class="flex flex-center pointer"
                  fillColor="#909090"
                  v-click-outside="closePopupMenu"
                  @click="changeShowPopupMenu"
                />
              </div>
              <popup-menu :isOpen="showSortPopupMenu" :items="sortTypes" :onSelect="onSelectedItem" />
            </div>
            <div v-else class="light-gray px-1 py-1">
              <span class="gray">Nolaノベルに作成済みの作品一覧</span>
            </div>
          </div>
          <div v-if="linkedNovel" class="flex-1 episode-list">
            <div class="w-full" :style="{ height: '1px', background: '#D6D6D6' }" />
            <div v-if="isLoading" class="flex flex-center py-1">
              <vue-loading type="spiningDubbles" color="#efad4c" :size="{ width: '25px', height: '25px' }" />
            </div>
            <div v-if="!isLoading && episodes.length === 0" class="h-full flex flex-center">
              <h3 class="text-center px-1" :style="{ lineHeight: '1.5rem' }">
                「{{ linkedNovel.title }}」にエピソードがありません。<br />
                Nolaで書いた原稿を投稿してみましょう！！
              </h3>
            </div>
            <template v-else>
              <div v-for="episode in episodes" :key="episode.id" class="episode-list-row">
                <div
                  class="flex flex-row px-1 gap-1 align-items-center"
                  :style="{ paddingTop: '1.0rem', paddingBottom: '1.0rem' }"
                >
                  <div class="flex-1 flex align-items-center" :style="{ minWidth: '0px' }">
                    <h3 class="line-3 w-full m-0">
                      {{ episode.title }}
                    </h3>
                  </div>
                  <div v-if="episode.episodeIdNola" class="btn disable">連携済み</div>
                  <div v-else class="btn select pointer" @click="onEpisodeSelect(episode)">選択</div>
                </div>
              </div>
            </template>
          </div>
          <div v-else class="flex-1 novel-list">
            <div class="w-full" :style="{ height: '1px', background: '#D6D6D6' }" />
            <div v-if="isLoading" class="flex flex-center py-1">
              <vue-loading type="spiningDubbles" color="#efad4c" :size="{ width: '25px', height: '25px' }" />
            </div>
            <div v-if="!isLoading && novels.length === 0" class="h-full flex flex-center">
              <h3 class="text-center" :style="{ lineHeight: '1.5rem' }">
                Nolaノベルに作品がありません。<br />
                まずはNolaの
                <span class="underline pointer" @click="onDetailNavigateClick"> 作品編集画面 </span>
                からNolaで書いた作品を投稿してみましょう！！
              </h3>
            </div>
            <template v-else>
              <div v-for="novel in novels" :key="novel.id" class="novel-list-row">
                <div
                  class="flex flex-row px-1 gap-1 align-items-center"
                  :style="{ paddingTop: '1.0rem', paddingBottom: '1.0rem' }"
                >
                  <div class="flex flex-center">
                    <image-view :src="getImagePath(novel)" :style="{ height: '70px', width: '50px' }" />
                  </div>
                  <div class="flex-1 flex align-items-center" :style="{ minWidth: '0px' }">
                    <h3 class="line-3 w-full m-0">
                      {{ novel.title }}
                    </h3>
                  </div>
                  <div class="btn select pointer" @click="onNovelSelect(novel)">選択</div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="flex flex-column flex-4 border-left-1 border-left-light-gray" :style="{ background: '#D1E1F4' }">
          <div class="flex-1 flex pt-1">
            <div class="align-self-center w-full h-full guide-image" />
          </div>
          <div class="w-full flex flex-column" :style="{ background: 'var(--color-background-normal)' }">
            <h2 :style="{ paddingLeft: '1.4rem', paddingRight: '1.4rem' }">
              Nolaノベルは、作家と編集者がつながる小説投稿サイトです
            </h2>
            <div class="light-gray m-0" :style="{ height: '0.3rem', marginLeft: '1.3rem', marginRight: '1.3rem' }" />
            <span class="pt-1 bold line-height-18" :style="{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }">
              Nolaノベルは、様々な企業の編集部が探している作品像を知り、編集者に向けて作品投稿できる小説投稿サイトです。
            </span>
            <span class="pb-1 bold line-height-18" :style="{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }">
              自分に合うレーベルを見つけたり、商業デビューに近づくきっかけとしてぜひご利用ください。
            </span>
            <div
              class="px-1 py-1 light-gray radius-8 bold mb-2"
              :style="{ marginLeft: '1.3rem', marginRight: '1.3rem' }"
            >
              Nola内のデータが許諾なく公開されるようなことはございませんので、ご安心いただけますと幸いです。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { EpisodeFromNolaNovel, Manuscript, Novel, NovelFromNolaNovel } from "@/lib/models";
import { VueLoading } from "vue-loading-template";
import ImageView from "@/components/atoms/ImageView.vue";
import PopupMenu from "@/components/molecules/PopupMenu.vue";
import ChevronLeftIcon from "icons/ChevronLeft.vue";
import SortVariantIcon from "icons/SortVariant.vue";
import { isAfter, isBefore } from "date-fns";
import { NolaNovelUrlGenerator } from "@/lib/utils/generator/nolanovelUrl";
import { createUrlWithUtmParams } from "@/lib/utils/url";
import { NolaItemId, NolaPageName } from "@/lib/utils/analytics";

const ClickOutside = require("vue-click-outside");

// ソートの種類
const SortType = {
  createdAsc: "作成日(昇順)",
  createdDesc: "作成日(降順)",
  updatedAsc: "更新日(昇順)",
  updatedDesc: "更新日(降順)",
  titleAsc: "タイトル(昇順)",
  titleDesc: "タイトル(降順)",
} as const;

// enumは使わない方がいいみたいだからunion型にしてみた
// eslint-disable-next-line no-redeclare
type SortType = typeof SortType[keyof typeof SortType];

interface Data {
  isLoading: boolean;
  isLinking: boolean;
  linkedNovel?: NovelFromNolaNovel;
  currentSortType?: SortType;
  showSortPopupMenu: boolean;
}

interface Methods {
  initialize: () => void;
  getAssociatedId: () => string | undefined;
  getImagePath: (novel: NovelFromNolaNovel) => string | null;
  getSortedEpisodes: (episodes: EpisodeFromNolaNovel[]) => EpisodeFromNolaNovel[];
  setDefaultLinkedNovel: () => NovelFromNolaNovel | undefined;
  onClickOutSide: () => void;
  onNegativeClick: () => void;
  onNovelSelect: (novel: NovelFromNolaNovel) => void;
  onEpisodeSelect: (episode: EpisodeFromNolaNovel) => void;
  onDetailNavigateClick: () => void;
  onSelectedItem: (item: SortType) => void;
  executeLink: (episode: EpisodeFromNolaNovel) => void;
  changeShowPopupMenu: () => void;
  closePopupMenu: () => void;
  navigateToNolaNovelEditPage: (episode?: EpisodeFromNolaNovel) => void;
  navigateToNovelDetailPage: () => void;
}

interface Computed {
  novel?: Novel;
  manuscript?: Manuscript;
  novels: NovelFromNolaNovel[];
  episodes: EpisodeFromNolaNovel[];
  sortTypes: string[];
}

interface Props {
  novelId: string;
  manuscriptId: string;
  isPost: boolean;
  novelIdFromNolaNovel?: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  directives: { ClickOutside },
  components: { VueLoading, ImageView, ChevronLeftIcon, PopupMenu, SortVariantIcon },

  created() {
    const { initialize } = this;
    initialize();
  },

  data() {
    return {
      isLoading: true,
      isLinking: false,
      linkedNovel: undefined,
      currentSortType: undefined,
      showSortPopupMenu: false,
    };
  },

  methods: {
    // initialize

    async initialize() {
      const { setDefaultLinkedNovel } = this;
      const result = setDefaultLinkedNovel();

      const { dispatch } = this.$store;
      await dispatch("nolaNovelModule/fetchNovels", {});

      if (!result) {
        setDefaultLinkedNovel();
      }

      this.isLoading = false;
    },

    // handle data

    getImagePath(novel) {
      const { imagePath } = novel;

      if (!imagePath) {
        return null;
      }

      return `nolaNovel:${novel.imagePath}`;
    },
    getAssociatedId() {
      const { novel } = this;
      if (!novel) {
        return undefined;
      }

      const { associatedData } = novel;

      if (!associatedData) {
        return undefined;
      }

      const { nolaNovel } = associatedData;

      if (!nolaNovel) {
        return undefined;
      }

      const { id } = nolaNovel;
      if (!id) {
        return undefined;
      }

      return id;
    },
    getSortedEpisodes(episodes) {
      return episodes.sort((a, b) => {
        const aCreatedDate = new Date(a.createdAt);
        const bCreatedDate = new Date(b.createdAt);
        const aUpdatedDate = new Date(a.updatedAt);
        const bUpdatedDate = new Date(b.updatedAt);

        switch (this.currentSortType) {
          case SortType.createdAsc:
            return isBefore(aCreatedDate, bCreatedDate) ? -1 : 1;
          case SortType.createdDesc:
            return isAfter(aCreatedDate, bCreatedDate) ? -1 : 1;
          case SortType.updatedAsc:
            return isBefore(aUpdatedDate, bUpdatedDate) ? -1 : 1;
          case SortType.updatedDesc:
            return isAfter(aUpdatedDate, bUpdatedDate) ? -1 : 1;
          case SortType.titleAsc:
            if (a.title && b.title) {
              return a.title.localeCompare(b.title);
            }
            if (a.title) {
              return a.title.localeCompare("");
            }
            if (b.title) {
              return "".localeCompare(b.title);
            }
            return 0;
          case SortType.titleDesc:
            if (a.title && b.title) {
              return b.title.localeCompare(a.title);
            }
            if (b.title) {
              return b.title.localeCompare("");
            }
            if (a.title) {
              return "".localeCompare(a.title);
            }
            return 0;
          default:
            return isAfter(aUpdatedDate, bUpdatedDate) ? -1 : 1;
        }
      });
    },
    setDefaultLinkedNovel() {
      const { novelIdFromNolaNovel } = this;
      if (novelIdFromNolaNovel) {
        const { getters } = this.$store;
        const novel = getters["nolaNovelModule/novel"](novelIdFromNolaNovel) as NovelFromNolaNovel | undefined;
        this.linkedNovel = novel;
        return novel;
      }

      return undefined;
    },

    // event handle

    onNegativeClick() {
      this.$close(false);
    },
    onClickOutSide() {
      this.$close(false);
    },
    onNovelSelect(novel) {
      const { isLoading } = this;

      if (isLoading) {
        return;
      }

      this.linkedNovel = novel;
    },
    onEpisodeSelect(episode) {
      const { isLoading, isPost, executeLink, navigateToNolaNovelEditPage } = this;

      if (isLoading) {
        return;
      }

      if (isPost) {
        navigateToNolaNovelEditPage(episode);
        return;
      }

      executeLink(episode);
    },
    onSelectedItem(item: SortType) {
      this.currentSortType = item;
      this.closePopupMenu();
    },
    onDetailNavigateClick() {
      this.$close(false);
      const { navigateToNovelDetailPage } = this;
      navigateToNovelDetailPage();
    },

    // execute

    async executeLink(episodeFromNolaNovel) {
      const { novelId, manuscriptId } = this;
      const { dispatch } = this.$store;
      try {
        this.isLinking = true;
        await dispatch("nolaNovelModule/addEpisodeLink", {
          novelId,
          manuscriptId,
          episode: episodeFromNolaNovel,
        });
      } catch (e) {
        this.$close(false);
        return;
      }

      this.$close(true);
    },
    changeShowPopupMenu() {
      this.showSortPopupMenu = !this.showSortPopupMenu;
    },
    closePopupMenu() {
      this.showSortPopupMenu = false;
    },
    async navigateToNolaNovelEditPage(episode) {
      const url = process.env.VUE_APP_NOLANOVEL_WEB;

      if (!url) {
        throw new Error("NolaノベルのWebサイトURLが環境変数に含まれていません。");
      }
      const { linkedNovel, novelId, manuscriptId } = this;

      if (!linkedNovel) {
        throw new Error("エピソードに紐づく作品が選択できていません。");
      }

      const service = new NolaNovelUrlGenerator(process.env.VUE_APP_NOLANOVEL_WEB!);

      if (episode) {
        const updateEpisodeUrl = await service.genUpdateEpisodeUrl(episode.id, novelId, manuscriptId);
        window.open(
          createUrlWithUtmParams(updateEpisodeUrl, NolaPageName.Editor, NolaItemId.SelectForOverwriteEpisodeButton),
          process.env.VUE_APP_NOLANOVEL_NAME
        );
        return;
      }

      const postEpisodeUrl = await service.genPostEpisodeUrl(linkedNovel.id, novelId, manuscriptId);
      window.open(
        createUrlWithUtmParams(postEpisodeUrl, NolaPageName.Editor, NolaItemId.SelectForNewEpisodePostButton),
        process.env.VUE_APP_NOLANOVEL_NAME
      );
    },
    navigateToNovelDetailPage() {
      const { $router, novelId } = this;
      $router.push({ name: "detail", params: { novelId } });
    },
  },

  computed: {
    novel() {
      const { novelId } = this;
      const { getters } = this.$store;
      return getters["novelModule/novel"](novelId);
    },
    manuscript() {
      const { manuscriptId } = this;
      const { getters } = this.$store;
      return getters["manuscriptModule/manuscript"](manuscriptId);
    },
    novels() {
      const { getters } = this.$store;
      return getters["nolaNovelModule/novels"];
    },
    episodes() {
      const { linkedNovel } = this;
      if (!linkedNovel) {
        return [];
      }

      const { getSortedEpisodes, currentSortType } = this;
      const { getters } = this.$store;
      const episodes = getters["nolaNovelModule/episodes"](linkedNovel.id);

      if (currentSortType) {
        return getSortedEpisodes(episodes);
      }

      return episodes;
    },
    sortTypes() {
      return Object.values(SortType);
    },
  },

  props: {
    novelId: String,
    manuscriptId: String,
    novelIdFromNolaNovel: String,
    isPost: {
      type: Boolean,
      default: false,
    },
  },
});

export type EpisodeListDialogProps = Props;
</script>

<style lang="scss" scoped>
// mask
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 9000;
  align-items: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

// container

.dialog {
  height: 750px;
  width: 850px;
  max-width: 90%;
  max-height: 80%;
}

.header {
  color: var(--color-text-on-fixed-bg);
  background-color: var(--color-bg-dark);
  padding: 0.8rem 1rem;
}

.content {
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-md);
  color: var(--color-text-normal);
  width: 100%;
  overflow-y: scroll;
}

.guide-image {
  background: url("../../../assets/img/static/guide_nolanovel.png");
  background-position: bottom;
  background-size: contain;
  background-repeat: no-repeat;
}

.novel-list,
.episode-list {
  max-height: 100%;
  overflow: scroll;

  &-row {
    width: 100%;
    border-bottom: 1px solid var(--color-border);
  }
}

.h-full {
  height: 100%;
}

.w-full {
  width: 100%;
}

.scroll {
  overflow: scroll;
}

// flex

.flex {
  display: flex;
}

.flex-row {
  flex-direction: row;
}

.flex-column {
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}

.flex-3 {
  flex: 3;
}

.flex-4 {
  flex: 4;
}

.flex-6 {
  flex: 6;
}

.flex-7 {
  flex: 7;
}

.gap-1 {
  gap: 1rem;
}

.space-between {
  justify-content: space-between;
}

.align-self-center {
  align-self: center;
}

.align-items-center {
  align-items: center;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

// button

.btn {
  padding: 0.5rem 1.5rem;
  border: 1px solid var(--color-border);
  line-height: initial;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);

  &.new {
    color: var(--color-text-on-fixed-bg);
    border: 1px solid var(--color-primary);
    background-color: var(--color-primary);
    border-color: var(--color-primary);
    padding: 0.3rem 0.5rem;
  }

  &.select {
    color: var(--color-primary);
    border: 1px solid var(--color-primary);
    padding: 0.3rem 0.5rem;
  }

  &.disable {
    padding: 0.3rem 0.5rem;
  }
}

.pointer {
  cursor: pointer;
}

// text

.underline {
  text-decoration: underline;
}

.user-select-none {
  user-select: none;
}

.bold {
  font-weight: var(--font-weight-bold);
}

.text-center {
  text-align: center;
}

.line-height-initial {
  line-height: initial;
}

.line-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;

  /*IE対策*/
  line-height: 1.2em;
  max-height: 3.6em;
}

// padding, margin

.pt-1 {
  padding-top: 1rem;
}

.pb-1 {
  padding-bottom: 1rem;
}

.px-1 {
  padding-right: 1rem;
  padding-left: 1rem;
}

.py-1 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.line-height-18 {
  line-height: 1.8;
}

.m-0 {
  margin: 0px;
}

.mb-2 {
  margin-bottom: 2rem;
}

// border

.radius-8 {
  border-radius: var(--radius-sm);
}

.border-left-1 {
  border-left: 1px solid;
}

.border-left-light-gray {
  border-left-color: var(--color-border);
}

// option

.loading {
  margin-bottom: 2rem;
}

.gray {
  color: var(--color-text-low);
}

.light-gray {
  background: var(--color-surface-muted);
}

.error {
  width: 100%;
  text-align: start;
  font-size: var(--font-size-xs);
  margin-top: 0.5rem;
  color: var(--color-warning);
}
</style>
